export default __webpack_public_path__ + "static/media/check.57a0393f.svg";